export const packsLimitPerRequest = 50;
export const accountsLimitPerScreen = 12;
export const unassignedId = 'unassignedPacks';
export const sharedId = 'sharedPacks';
